import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { setDatabaseContext } from './context'

/**
 * Hook that automatically sets Sentry database context based on route params
 */
export function useSentryDatabaseContext(): void {
  const params = useParams<{ appId?: string }>()

  useEffect(() => {
    // Set database context when appId is present in URL params
    // Note: appId and databaseId are the same thing
    setDatabaseContext(params?.appId)

    // Clear database context when component unmounts or appId changes
    return () => {
      if (params?.appId) {
        setDatabaseContext(null)
      }
    }
  }, [params.appId])
}

/**
 * Hook to manually set database context when databaseId comes from props or other sources
 * Use this when databaseId (appId) is not in the URL params
 */
export function useManualSentryDatabaseContext(
  databaseId: string | null | undefined,
): void {
  useEffect(() => {
    setDatabaseContext(databaseId)

    return () => {
      if (databaseId) {
        setDatabaseContext(null)
      }
    }
  }, [databaseId])
}
